import { render } from "./PlayoutTable.vue?vue&type=template&id=64daf2fb&scoped=true"
import script from "./PlayoutTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutTable.vue?vue&type=script&setup=true&lang=js"

import "./PlayoutTable.vue?vue&type=style&index=0&id=64daf2fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64daf2fb"],['__file',"src/components/TVPlayout/PlayoutTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64daf2fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64daf2fb', __exports__)) {
    api.reload('64daf2fb', __exports__)
  }
  
  module.hot.accept("./PlayoutTable.vue?vue&type=template&id=64daf2fb&scoped=true", () => {
    api.rerender('64daf2fb', render)
  })

}


export default __exports__